import React from "react";

import FatherLayout from "../../components/Parents/FatherLayout";
import BlogDetail from "../../components/Parents/Blog/BlogDetail";

function Blog() {
    return (
        <FatherLayout noTitle showWelcomeBanner={true}>
            <BlogDetail/>
        </FatherLayout>
    );
}

export default Blog;
